module.exports = __webpack_public_path__ + "img/mark_as_paid_disabled.aee9e376.svg";